import React, {useState, useEffect} from 'react'
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { CardActions } from '@mui/material';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import Divider from '@mui/material/Divider';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { Button, TextField } from '@mui/material';
import { useMutation } from "react-query";
import apiClient from '../../request/http-common';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useSelector } from 'react-redux';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const Editwallet = () => {
    const params = useParams();
    const [wallet, setwallet] = useState(null);
    const { isLoading: isLoadingwallets, refetch: getwallets } = useQuery(
        "edit-wallet",
        async () => {
          return await apiClient.get(`/api/edit-wallet/${params.id}`);
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setwallet(res.data.wallet);
                setwalletForm({...walletForm, 
                    name : res.data.wallet.coin_name	,
                    address : res.data.wallet.address	,
                    wallet_type: res.data.wallet.wallet_type || '',
                    display_area: res.data.wallet.display_area || '',
                    terms : res.data.wallet.terms || '',
                    percentage : res.data.wallet.percentage || '',
                    orders : res.data.wallet.orders || '',
                    payment_description : res.data.wallet.payment_description || '',
                    max : res.data.wallet.max || '',
                    min : res.data.wallet.min || '',
                    quantity : res.data.wallet.quantity || '',
                    trader_name : res.data.wallet.trader_name || '',
                });
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      
    const dispatch = useDispatch();
    
    const initialLogin = {
        name : ''	,
        address : '',
        wallet_type: '',
        display_area: '',
        terms : '',
        percentage : '',
        orders : '',
        payment_description : '',
        max : '',
        min : '',
        quantity : '',
        trader_name : '',
        image: null,
    }
    
    
    const [error, setErros] = useState('');
    const [walletForm, setwalletForm] = useState(initialLogin);

    const onChange = (e) =>
    setwalletForm({ ...walletForm, [e.target.name]: e.target.value });

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setwalletForm({ ...walletForm, image: file });
        }
    };


    const { isLoading: isSendingRequest, mutate: postwallet } = useMutation(

        async () => {
          const formData = new FormData();
          formData.append('coin_name', walletForm.name);
          formData.append('address', walletForm.address);
          formData.append('wallet_type', walletForm.wallet_type);
          formData.append('display_area', walletForm.display_area);
          formData.append('terms', walletForm.terms);
          formData.append('percentage', walletForm.percentage);
          formData.append('orders', walletForm.orders);
          formData.append('payment_description', walletForm.payment_description);
          formData.append('max', walletForm.max);
          formData.append('min', walletForm.min);
          formData.append('quantity', walletForm.quantity);
          formData.append('trader_name', walletForm.trader_name);
          
          if (walletForm.image) {
            formData.append('image', walletForm.image);
          }

          return await apiClient.post(`/api/update-wallet/${params.id}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        },
        {
          onSuccess: (res) => {
            localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event2 = new Event('processed');
            window.dispatchEvent(event2);
          },
          onError: (err) => {   
            let myerror = err.response?.data || err;         
            setErros(myerror.errors)  
            const event2 = new Event('processed');
            window.dispatchEvent(event2);     
          },
        }
      );
      const onSubmit = () =>{
        const event3 = new Event('processing');
        window.dispatchEvent(event3);
        postwallet();
      } 

      useEffect(() => {
        getwallets();
      }, []);

  return (
    <div style={{marginTop: '70px'}}>
        {wallet !== null && 

        <Grid container px={2} mt={4}  mb={4} rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid item xs={12} md={12}>
                <Card sx={{marginX: '5px', borderRadius: '9px', height: '100%'}}>
                    <CardContent>
                    <Typography mt={4} sx={{ fontWeight: 'bold', fontSize: 24, textAlign: 'center'  }} gutterBottom variant="h6" component="div">
                        EDIT WALLET ADDRESS
                    </Typography>
                    <Typography  sx={{  textAlign: 'center', fontSize: 16  }} variant="subtitle1" gutterBottom>
                        Fill the form below to edit wallet address
                    </Typography>

                    <FormControl  fullWidth={true} sx={{ m: 1, minWidth: 50, marginBottom: '10px' }}>
                      <InputLabel htmlFor="display_area">Display Area</InputLabel>
                      <Select
                          onChange={onChange}
                          defaultValue={wallet.display_area}
                          labelId="display_area"
                          name="display_area"
                          id="display_area"
                          label={`Display Area`}
                          >
                          <MenuItem selected value=''>
                            Select where to display this payment method
                            </MenuItem> 
                          <MenuItem selected value='withdrawals'>
                          withdrawals
                          </MenuItem> 
                          <MenuItem selected value='payments'>
                          deposits/payments
                          </MenuItem> 
                      </Select>                        
                    </FormControl>

                    <FormControl  fullWidth={true} sx={{ m: 1, minWidth: 50, marginBottom: '10px' }}>
                      <InputLabel htmlFor="wallet_type">Wallet Type</InputLabel>
                      <Select
                          onChange={onChange}
                          defaultValue={wallet.wallet_type}
                          labelId="wallet_type"
                          name="wallet_type"
                          id="wallet_type"
                          label={`Wallet Type`}
                          >
                          <MenuItem selected value=''>
                            Select Option
                            </MenuItem> 
                          <MenuItem selected value='bank'>
                          Bank
                          </MenuItem> 
                          <MenuItem selected value='Crypto'>
                          Crypto
                          </MenuItem> 
                      </Select>                        
                    </FormControl>

                    <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="Wallet Name">wallet Name/Bank Name</InputLabel>
                            {(error !== '' && error.name) ?
                            <OutlinedInput
                            error
                            onChange={onChange}
                            defaultValue={wallet.coin_name}
                            id="name"
                            name="name"
                            type={'text'}
                            label="wallet Name/Bank Name"
                            helperText={error.name}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            defaultValue={wallet.coin_name}
                            id="name"
                            name="name"
                            type={'text'}
                            label="wallet Name/Bank Name"
                            />
                            }
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.name}
                            </Typography>
                            
                        </FormControl>

                        

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="address">Address/Bank Account Details</InputLabel>
                            {(error !== '' && error.address) ?

                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="address"
                            defaultValue={wallet.address}
                            type={'text'}
                            name="address"
                            label="Address/Bank Account Details"
                            helperText={error.address}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            defaultValue={wallet.address}
                            id="address"
                            type={'text'}
                            name="address"
                            label="Address/Bank Account Details"
                            />
                            }
                            <Typography color='error'  sx={{  textAlign: 'left', fontSize: 16  }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.address}
                            </Typography>
                            
                        </FormControl>

                        <Typography variant='h4' sx={{ my: 2 }}>
                          FOR P2P ORDERS
                        </Typography>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="trader_name">Trader Name</InputLabel>
                            {(error !== '' && error.trader_name) ?
                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="trader_name"
                            type={'text'}
                            name="trader_name"
                            defaultValue={wallet?.trader_name || ''}
                            label="Trader Name"
                            helperText={error.trader_name}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="trader_name"
                            type={'text'}
                            name="trader_name"
                            defaultValue={wallet?.trader_name || ''}
                            label="Trader Name"
                            />
                            }
                            <Typography color='error' sx={{ textAlign: 'left', fontSize: 16 }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.trader_name}
                            </Typography>
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="quantity">Quantity (USD)</InputLabel>
                            {(error !== '' && error.quantity) ?
                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="quantity"
                            type={'number'}
                            name="quantity"
                            defaultValue={wallet?.quantity || ''}
                            label="Quantity (USD)"
                            helperText={error.quantity}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="quantity"
                            type={'number'}
                            name="quantity"
                            defaultValue={wallet?.quantity || ''}
                            label="Quantity (USD)"
                            />
                            }
                            <Typography color='error' sx={{ textAlign: 'left', fontSize: 16 }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.quantity}
                            </Typography>
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="min">Min (USD)</InputLabel>
                            {(error !== '' && error.min) ?
                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="min"
                            type={'number'}
                            name="min"
                            defaultValue={wallet?.min || ''}
                            label="Min (USD)"
                            helperText={error.min}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="min"
                            type={'number'}
                            name="min"
                            defaultValue={wallet?.min || ''}
                            label="Min (USD)"
                            />
                            }
                            <Typography color='error' sx={{ textAlign: 'left', fontSize: 16 }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.min}
                            </Typography>
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="max">Max (USD)</InputLabel>
                            {(error !== '' && error.max) ?
                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="max"
                            type={'number'}
                            name="max"
                            defaultValue={wallet?.max || ''}
                            label="Max (USD)"
                            helperText={error.max}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="max"
                            type={'number'}
                            name="max"
                            defaultValue={wallet?.max || ''}
                            label="Max (USD)"
                            />
                            }
                            <Typography color='error' sx={{ textAlign: 'left', fontSize: 16 }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.max}
                            </Typography>
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="payment_description">Payment Method</InputLabel>
                            {(error !== '' && error.payment_description) ?
                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="payment_description"
                            type={'text'}
                            name="payment_description"
                            defaultValue={wallet?.payment_description || ''}
                            label="Payment Method"
                            helperText={error.payment_description}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="payment_description"
                            type={'text'}
                            name="payment_description"
                            defaultValue={wallet?.payment_description || ''}
                            label="Payment Method"
                            />
                            }
                            <Typography color='error' sx={{ textAlign: 'left', fontSize: 16 }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.payment_description}
                            </Typography>
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="orders">Orders</InputLabel>
                            {(error !== '' && error.orders) ?
                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="orders"
                            type={'number'}
                            name="orders"
                            defaultValue={wallet?.orders || ''}
                            label="Num Orders"
                            helperText={error.orders}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="orders"
                            type={'number'}
                            name="orders"
                            defaultValue={wallet?.orders || ''}
                            label="Num Orders"
                            />
                            }
                            <Typography color='error' sx={{ textAlign: 'left', fontSize: 16 }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.orders}
                            </Typography>
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="percentage">Percentage</InputLabel>
                            {(error !== '' && error.percentage) ?
                            <OutlinedInput
                            onChange={onChange}
                            error
                            id="percentage"
                            type={'number'}
                            name="percentage"
                            defaultValue={wallet?.percentage || ''}
                            label="Percentage"
                            helperText={error.percentage}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            id="percentage"
                            type={'number'}
                            name="percentage"
                            defaultValue={wallet?.percentage || ''}
                            label="Percentage"
                            />
                            }
                            <Typography color='error' sx={{ textAlign: 'left', fontSize: 16 }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.percentage}
                            </Typography>
                        </FormControl>

                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <InputLabel htmlFor="terms">Terms</InputLabel>
                            {(error !== '' && error.terms) ?
                            <OutlinedInput
                            onChange={onChange}
                            multiline
                            rows={4}
                            error
                            id="terms"
                            type={'text'}
                            name="terms"
                            defaultValue={wallet?.terms || ''}
                            label="Terms"
                            helperText={error.terms}
                            />
                            :
                            <OutlinedInput
                            onChange={onChange}
                            multiline
                            rows={4}
                            id="terms"
                            type={'text'}
                            name="terms"
                            defaultValue={wallet?.terms || ''}
                            label="Terms"
                            />
                            }
                            <Typography color='error' sx={{ textAlign: 'left', fontSize: 16 }} variant="subtitle1" gutterBottom>
                            {error !== '' && error.terms}
                            </Typography>
                        </FormControl>

                        {/* Image Upload Field */}
                        <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                                Wallet Icon/Image (Optional)
                            </Typography>
                            {wallet?.image && (
                                <Box sx={{ mb: 2, textAlign: 'center' }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                        Current Image:
                                    </Typography>
                                    <img 
                                        src={wallet.image} 
                                        alt="Current wallet icon" 
                                        style={{ 
                                            maxWidth: '100px', 
                                            maxHeight: '100px', 
                                            borderRadius: '8px',
                                            border: '2px solid #e0e0e0'
                                        }} 
                                    />
                                </Box>
                            )}
                            <Box sx={{ 
                                border: '2px dashed #ccc', 
                                borderRadius: 2, 
                                p: 3, 
                                textAlign: 'center',
                                backgroundColor: '#fafafa',
                                '&:hover': {
                                    borderColor: '#1976d2',
                                    backgroundColor: '#f5f5f5'
                                }
                            }}>
                                <input
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    id="image-upload"
                                    type="file"
                                    onChange={handleImageChange}
                                />
                                <label htmlFor="image-upload">
                                    <Button
                                        component="span"
                                        variant="outlined"
                                        startIcon={<CloudUploadIcon />}
                                        sx={{ mb: 2 }}
                                    >
                                        Upload New Image
                                    </Button>
                                </label>
                                {walletForm.image && (
                                    <Box sx={{ mt: 2 }}>
                                        <Typography variant="body2" color="text.secondary">
                                            Selected: {walletForm.image.name}
                                        </Typography>
                                        <Button 
                                            size="small" 
                                            color="error" 
                                            onClick={() => setwalletForm({ ...walletForm, image: null })}
                                            sx={{ mt: 1 }}
                                        >
                                            Remove
                                        </Button>
                                    </Box>
                                )}
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                                    Upload a custom icon for this wallet. Will be used as fallback if dynamic coin image is not available.
                                </Typography>
                            </Box>
                            <Typography color='error' sx={{ textAlign: 'left', fontSize: 16 }} variant="subtitle1" gutterBottom>
                                {error !== '' && error.image}
                            </Typography>
                        </FormControl>

                        
                    </CardContent>   

                    <CardActions>
                        <Button onClick={onSubmit} fullWidth={true} size="large" color="primary" variant="contained"> {isSendingRequest? 'Updating...' : 'Update wallet'}</Button>
                    </CardActions>
                </Card>
            </Grid>
        </Grid>
        }
    </div>
  )
}

export default Editwallet
